function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { parseFilterArgs, parseQueryArgs, functionalUpdate, noop, hashQueryKey, partialMatchKey, hashQueryKeyByOptions } from './utils.esm.js';
import { QueryCache } from './queryCache.esm.js';
import { MutationCache } from './mutationCache.esm.js';
import { focusManager } from './focusManager.esm.js';
import { onlineManager } from './onlineManager.esm.js';
import { notifyManager } from './notifyManager.esm.js';
import { infiniteQueryBehavior } from './infiniteQueryBehavior.esm.js';
import { defaultLogger } from './logger.esm.js';

// CLASS
var QueryClient = /*#__PURE__*/function () {
  function QueryClient() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, QueryClient);
    this.queryCache = config.queryCache || new QueryCache();
    this.mutationCache = config.mutationCache || new MutationCache();
    this.logger = config.logger || defaultLogger;
    this.defaultOptions = config.defaultOptions || {};
    this.queryDefaults = [];
    this.mutationDefaults = [];
    this.mountCount = 0;
    if (process.env.NODE_ENV !== 'production' && config.logger) {
      this.logger.error("Passing a custom logger has been deprecated and will be removed in the next major version.");
    }
  }
  return _createClass(QueryClient, [{
    key: "mount",
    value: function mount() {
      var _this = this;
      this.mountCount++;
      if (this.mountCount !== 1) return;
      this.unsubscribeFocus = focusManager.subscribe(function () {
        if (focusManager.isFocused()) {
          _this.resumePausedMutations();
          _this.queryCache.onFocus();
        }
      });
      this.unsubscribeOnline = onlineManager.subscribe(function () {
        if (onlineManager.isOnline()) {
          _this.resumePausedMutations();
          _this.queryCache.onOnline();
        }
      });
    }
  }, {
    key: "unmount",
    value: function unmount() {
      var _this$unsubscribeFocu, _this$unsubscribeOnli;
      this.mountCount--;
      if (this.mountCount !== 0) return;
      (_this$unsubscribeFocu = this.unsubscribeFocus) == null ? void 0 : _this$unsubscribeFocu.call(this);
      this.unsubscribeFocus = undefined;
      (_this$unsubscribeOnli = this.unsubscribeOnline) == null ? void 0 : _this$unsubscribeOnli.call(this);
      this.unsubscribeOnline = undefined;
    }
  }, {
    key: "isFetching",
    value: function isFetching(arg1, arg2) {
      var _parseFilterArgs = parseFilterArgs(arg1, arg2),
        _parseFilterArgs2 = _slicedToArray(_parseFilterArgs, 1),
        filters = _parseFilterArgs2[0];
      filters.fetchStatus = 'fetching';
      return this.queryCache.findAll(filters).length;
    }
  }, {
    key: "isMutating",
    value: function isMutating(filters) {
      return this.mutationCache.findAll(_objectSpread(_objectSpread({}, filters), {}, {
        fetching: true
      })).length;
    }
  }, {
    key: "getQueryData",
    value: function getQueryData(queryKey, filters) {
      var _this$queryCache$find;
      return (_this$queryCache$find = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find.state.data;
    }
  }, {
    key: "ensureQueryData",
    value: function ensureQueryData(arg1, arg2, arg3) {
      var parsedOptions = parseQueryArgs(arg1, arg2, arg3);
      var cachedData = this.getQueryData(parsedOptions.queryKey);
      return cachedData ? Promise.resolve(cachedData) : this.fetchQuery(parsedOptions);
    }
  }, {
    key: "getQueriesData",
    value: function getQueriesData(queryKeyOrFilters) {
      return this.getQueryCache().findAll(queryKeyOrFilters).map(function (_ref2) {
        var queryKey = _ref2.queryKey,
          state = _ref2.state;
        var data = state.data;
        return [queryKey, data];
      });
    }
  }, {
    key: "setQueryData",
    value: function setQueryData(queryKey, updater, options) {
      var query = this.queryCache.find(queryKey);
      var prevData = query == null ? void 0 : query.state.data;
      var data = functionalUpdate(updater, prevData);
      if (typeof data === 'undefined') {
        return undefined;
      }
      var parsedOptions = parseQueryArgs(queryKey);
      var defaultedOptions = this.defaultQueryOptions(parsedOptions);
      return this.queryCache.build(this, defaultedOptions).setData(data, _objectSpread(_objectSpread({}, options), {}, {
        manual: true
      }));
    }
  }, {
    key: "setQueriesData",
    value: function setQueriesData(queryKeyOrFilters, updater, options) {
      var _this2 = this;
      return notifyManager.batch(function () {
        return _this2.getQueryCache().findAll(queryKeyOrFilters).map(function (_ref3) {
          var queryKey = _ref3.queryKey;
          return [queryKey, _this2.setQueryData(queryKey, updater, options)];
        });
      });
    }
  }, {
    key: "getQueryState",
    value: function getQueryState(queryKey, filters) {
      var _this$queryCache$find2;
      return (_this$queryCache$find2 = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find2.state;
    }
  }, {
    key: "removeQueries",
    value: function removeQueries(arg1, arg2) {
      var _parseFilterArgs3 = parseFilterArgs(arg1, arg2),
        _parseFilterArgs4 = _slicedToArray(_parseFilterArgs3, 1),
        filters = _parseFilterArgs4[0];
      var queryCache = this.queryCache;
      notifyManager.batch(function () {
        queryCache.findAll(filters).forEach(function (query) {
          queryCache.remove(query);
        });
      });
    }
  }, {
    key: "resetQueries",
    value: function resetQueries(arg1, arg2, arg3) {
      var _this3 = this;
      var _parseFilterArgs5 = parseFilterArgs(arg1, arg2, arg3),
        _parseFilterArgs6 = _slicedToArray(_parseFilterArgs5, 2),
        filters = _parseFilterArgs6[0],
        options = _parseFilterArgs6[1];
      var queryCache = this.queryCache;
      var refetchFilters = _objectSpread({
        type: 'active'
      }, filters);
      return notifyManager.batch(function () {
        queryCache.findAll(filters).forEach(function (query) {
          query.reset();
        });
        return _this3.refetchQueries(refetchFilters, options);
      });
    }
  }, {
    key: "cancelQueries",
    value: function cancelQueries(arg1, arg2, arg3) {
      var _this4 = this;
      var _parseFilterArgs7 = parseFilterArgs(arg1, arg2, arg3),
        _parseFilterArgs8 = _slicedToArray(_parseFilterArgs7, 2),
        filters = _parseFilterArgs8[0],
        _parseFilterArgs8$ = _parseFilterArgs8[1],
        cancelOptions = _parseFilterArgs8$ === void 0 ? {} : _parseFilterArgs8$;
      if (typeof cancelOptions.revert === 'undefined') {
        cancelOptions.revert = true;
      }
      var promises = notifyManager.batch(function () {
        return _this4.queryCache.findAll(filters).map(function (query) {
          return query.cancel(cancelOptions);
        });
      });
      return Promise.all(promises).then(noop).catch(noop);
    }
  }, {
    key: "invalidateQueries",
    value: function invalidateQueries(arg1, arg2, arg3) {
      var _this5 = this;
      var _parseFilterArgs9 = parseFilterArgs(arg1, arg2, arg3),
        _parseFilterArgs10 = _slicedToArray(_parseFilterArgs9, 2),
        filters = _parseFilterArgs10[0],
        options = _parseFilterArgs10[1];
      return notifyManager.batch(function () {
        var _ref, _filters$refetchType;
        _this5.queryCache.findAll(filters).forEach(function (query) {
          query.invalidate();
        });
        if (filters.refetchType === 'none') {
          return Promise.resolve();
        }
        var refetchFilters = _objectSpread(_objectSpread({}, filters), {}, {
          type: (_ref = (_filters$refetchType = filters.refetchType) != null ? _filters$refetchType : filters.type) != null ? _ref : 'active'
        });
        return _this5.refetchQueries(refetchFilters, options);
      });
    }
  }, {
    key: "refetchQueries",
    value: function refetchQueries(arg1, arg2, arg3) {
      var _this6 = this;
      var _parseFilterArgs11 = parseFilterArgs(arg1, arg2, arg3),
        _parseFilterArgs12 = _slicedToArray(_parseFilterArgs11, 2),
        filters = _parseFilterArgs12[0],
        options = _parseFilterArgs12[1];
      var promises = notifyManager.batch(function () {
        return _this6.queryCache.findAll(filters).filter(function (query) {
          return !query.isDisabled();
        }).map(function (query) {
          var _options$cancelRefetc;
          return query.fetch(undefined, _objectSpread(_objectSpread({}, options), {}, {
            cancelRefetch: (_options$cancelRefetc = options == null ? void 0 : options.cancelRefetch) != null ? _options$cancelRefetc : true,
            meta: {
              refetchPage: filters.refetchPage
            }
          }));
        });
      });
      var promise = Promise.all(promises).then(noop);
      if (!(options != null && options.throwOnError)) {
        promise = promise.catch(noop);
      }
      return promise;
    }
  }, {
    key: "fetchQuery",
    value: function fetchQuery(arg1, arg2, arg3) {
      var parsedOptions = parseQueryArgs(arg1, arg2, arg3);
      var defaultedOptions = this.defaultQueryOptions(parsedOptions); // https://github.com/tannerlinsley/react-query/issues/652

      if (typeof defaultedOptions.retry === 'undefined') {
        defaultedOptions.retry = false;
      }
      var query = this.queryCache.build(this, defaultedOptions);
      return query.isStaleByTime(defaultedOptions.staleTime) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
    }
  }, {
    key: "prefetchQuery",
    value: function prefetchQuery(arg1, arg2, arg3) {
      return this.fetchQuery(arg1, arg2, arg3).then(noop).catch(noop);
    }
  }, {
    key: "fetchInfiniteQuery",
    value: function fetchInfiniteQuery(arg1, arg2, arg3) {
      var parsedOptions = parseQueryArgs(arg1, arg2, arg3);
      parsedOptions.behavior = infiniteQueryBehavior();
      return this.fetchQuery(parsedOptions);
    }
  }, {
    key: "prefetchInfiniteQuery",
    value: function prefetchInfiniteQuery(arg1, arg2, arg3) {
      return this.fetchInfiniteQuery(arg1, arg2, arg3).then(noop).catch(noop);
    }
  }, {
    key: "resumePausedMutations",
    value: function resumePausedMutations() {
      return this.mutationCache.resumePausedMutations();
    }
  }, {
    key: "getQueryCache",
    value: function getQueryCache() {
      return this.queryCache;
    }
  }, {
    key: "getMutationCache",
    value: function getMutationCache() {
      return this.mutationCache;
    }
  }, {
    key: "getLogger",
    value: function getLogger() {
      return this.logger;
    }
  }, {
    key: "getDefaultOptions",
    value: function getDefaultOptions() {
      return this.defaultOptions;
    }
  }, {
    key: "setDefaultOptions",
    value: function setDefaultOptions(options) {
      this.defaultOptions = options;
    }
  }, {
    key: "setQueryDefaults",
    value: function setQueryDefaults(queryKey, options) {
      var result = this.queryDefaults.find(function (x) {
        return hashQueryKey(queryKey) === hashQueryKey(x.queryKey);
      });
      if (result) {
        result.defaultOptions = options;
      } else {
        this.queryDefaults.push({
          queryKey: queryKey,
          defaultOptions: options
        });
      }
    }
  }, {
    key: "getQueryDefaults",
    value: function getQueryDefaults(queryKey) {
      if (!queryKey) {
        return undefined;
      } // Get the first matching defaults

      var firstMatchingDefaults = this.queryDefaults.find(function (x) {
        return partialMatchKey(queryKey, x.queryKey);
      }); // Additional checks and error in dev mode

      if (process.env.NODE_ENV !== 'production') {
        // Retrieve all matching defaults for the given key
        var matchingDefaults = this.queryDefaults.filter(function (x) {
          return partialMatchKey(queryKey, x.queryKey);
        }); // It is ok not having defaults, but it is error prone to have more than 1 default for a given key

        if (matchingDefaults.length > 1) {
          this.logger.error("[QueryClient] Several query defaults match with key '" + JSON.stringify(queryKey) + "'. The first matching query defaults are used. Please check how query defaults are registered. Order does matter here. cf. https://react-query.tanstack.com/reference/QueryClient#queryclientsetquerydefaults.");
        }
      }
      return firstMatchingDefaults == null ? void 0 : firstMatchingDefaults.defaultOptions;
    }
  }, {
    key: "setMutationDefaults",
    value: function setMutationDefaults(mutationKey, options) {
      var result = this.mutationDefaults.find(function (x) {
        return hashQueryKey(mutationKey) === hashQueryKey(x.mutationKey);
      });
      if (result) {
        result.defaultOptions = options;
      } else {
        this.mutationDefaults.push({
          mutationKey: mutationKey,
          defaultOptions: options
        });
      }
    }
  }, {
    key: "getMutationDefaults",
    value: function getMutationDefaults(mutationKey) {
      if (!mutationKey) {
        return undefined;
      } // Get the first matching defaults

      var firstMatchingDefaults = this.mutationDefaults.find(function (x) {
        return partialMatchKey(mutationKey, x.mutationKey);
      }); // Additional checks and error in dev mode

      if (process.env.NODE_ENV !== 'production') {
        // Retrieve all matching defaults for the given key
        var matchingDefaults = this.mutationDefaults.filter(function (x) {
          return partialMatchKey(mutationKey, x.mutationKey);
        }); // It is ok not having defaults, but it is error prone to have more than 1 default for a given key

        if (matchingDefaults.length > 1) {
          this.logger.error("[QueryClient] Several mutation defaults match with key '" + JSON.stringify(mutationKey) + "'. The first matching mutation defaults are used. Please check how mutation defaults are registered. Order does matter here. cf. https://react-query.tanstack.com/reference/QueryClient#queryclientsetmutationdefaults.");
        }
      }
      return firstMatchingDefaults == null ? void 0 : firstMatchingDefaults.defaultOptions;
    }
  }, {
    key: "defaultQueryOptions",
    value: function defaultQueryOptions(options) {
      if (options != null && options._defaulted) {
        return options;
      }
      var defaultedOptions = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, this.defaultOptions.queries), this.getQueryDefaults(options == null ? void 0 : options.queryKey)), options), {}, {
        _defaulted: true
      });
      if (!defaultedOptions.queryHash && defaultedOptions.queryKey) {
        defaultedOptions.queryHash = hashQueryKeyByOptions(defaultedOptions.queryKey, defaultedOptions);
      } // dependent default values

      if (typeof defaultedOptions.refetchOnReconnect === 'undefined') {
        defaultedOptions.refetchOnReconnect = defaultedOptions.networkMode !== 'always';
      }
      if (typeof defaultedOptions.useErrorBoundary === 'undefined') {
        defaultedOptions.useErrorBoundary = !!defaultedOptions.suspense;
      }
      return defaultedOptions;
    }
  }, {
    key: "defaultMutationOptions",
    value: function defaultMutationOptions(options) {
      if (options != null && options._defaulted) {
        return options;
      }
      return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, this.defaultOptions.mutations), this.getMutationDefaults(options == null ? void 0 : options.mutationKey)), options), {}, {
        _defaulted: true
      });
    }
  }, {
    key: "clear",
    value: function clear() {
      this.queryCache.clear();
      this.mutationCache.clear();
    }
  }]);
}();
export { QueryClient };